import React from 'react';

import {Button, Modal} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import Assets from '../../../helpers/assets';
import Colors from '../../../helpers/Colors';
import {ModalStyles} from './CubbyModalStyles';

export function CubbyAssignmentFailedModal({isOpen, onClose}) {
    const style = ModalStyles();

    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            disableBackdropClick
            style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}
        >
            <div className={style.container}>
                <IconButton className={style.closeButton} onClick={onClose}><CloseIcon/></IconButton>
                <div className={style.body}>
                    <div className={style.leftPanel}>
                        <img src={Assets.conflictDetected.default} alt="assignment failed"/>
                    </div>
                    <div className={style.rightPanel}>
                        <div className={style.titleText}>Sorry, assignment is not successful.</div>
                        <div className={style.subText}>Please try again.</div>
                        <div className={style.buttonContainer}>
                            <Button type="submit"
                                    variant="outlined"
                                    fullWidth
                                    style={{color: Colors.grubtechBlue, borderColor: Colors.grubtechBlue}}
                                    onClick={onClose}
                                    className={style.button}>Got It
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}